import React, { Component } from 'react';

import MatrixLine from './MatrixLine'

import Grid from '@material-ui/core/Grid';
// import SvgIcon from '@material-ui/core/SvgIcon';

import ChartMenu from './../ChartMenu/ChartMenu'
// import CustomTooltip from './DoughnutTooltip';

import './matrixStyle.css'


class MatrixComponent extends Component {

  cant = () => {
    let all = this.props.data;
    let total = 0;
    for (let i = 0; i < all.length; i++) {
      for (let j = 0; j < all[i].horas.length; j++) {
        total = total + all[i].horas[j];
      }
    }
    return total;
  }
  getHoraDia = (index) => {
    const { data } = this.props;
    if (data.length === 4) {
      switch (index) {
        case 0: return 'L';
        case 1: return 'M';
        case 2: return 'M';
        case 3: return 'J';
        case 4: return 'V';
        case 5: return 'S';
        case 6: return 'D';
        default: return '';
      }
    }
    return index;
  }
  getDate = () => {
    try {
      return (
        <Grid container>
          <Grid item xs={12} className="text-center client-label-second-color font-12">
            Actulizado a: {this.props.date.split('T')[0]}
          </Grid>
        </Grid>
      )
    } catch (e) { }
  }

  getLegend = (index) => {
    if (this.props.data.length === 4) { 
      switch (index) {
        case 1: return '<3%';
        case 2: return '3%-6%';
        case 3: return '6%-9%';
        case 4: return '>9%';
        default: return '';
      }
    } else {      
      switch (index) {
        case 1: return '<0.3%';
        case 2: return '0.3%-0.6%';
        case 3: return '0.6%-0.9%';
        case 4: return '>0.9%';
        default: return '';
      }
    }
  }

  render() {

    return (
      <Grid container id={this.props.name}>
        <ChartMenu graph={this.props.name} file={this.props.title}
          openDialog={this.props.openDialog} title={this.props.title} watch={this.props.watchMenu}
          seeMore={this.props.seeMore} />
        <Grid container>
          <Grid item xs={1}></Grid>
          <Grid item xs={11} className="client-label-second-color">
            <div className="ancho ancho-flex">
              <div className={"panel-square mr-10"} key={1} >{this.getLegend(1)}</div>
              <div className={"panel-square mr-10"} key={2} >{this.getLegend(2)}</div>
              <div className={"panel-square mr-10"} key={3} >{this.getLegend(3)}</div>
              <div className={"panel-square mr-10"} key={4} >{this.getLegend(4)}</div>
            </div>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={11} className="client-label-second-color">
            <div className="ancho ancho-flex">
              <div className={"panel-square-legend color-1 mr-10 panel-leyend"} key={1} ></div>
              <div className={"panel-square-legend color-2 mr-10 panel-leyend"} key={2} ></div>
              <div className={"panel-square-legend color-3 mr-10 panel-leyend"} key={3} ></div>
              <div className={"panel-square-legend color-4 mr-10 panel-leyend"} key={4} ></div>
            </div>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={11} style={{ textAlign: 'center' }}>
            {this.props.data.length === 4 ? 'Día de la semana' : 'Hora del día'}
          </Grid>
          <Grid container>
            <Grid item xs={1} style={{ whiteSpace:'nowrap', transform: 'rotate(-90deg)',  paddingTop:'115px' }}>
              {this.props.data.length === 4 ? 'Jornada' : 'Día de la semana'}
            </Grid>
            <Grid item xs={11}>
              <div className={"ancho ancho-" + this.props.data[0].horas.length}>
                <div variant="outlined" className={"panel-title"} key={100000} style={{ width: '14px' }} ></div>
                {this.props.data[0].horas.map((val, i) =>
                  <div variant="outlined" className={"panel-title panel-square-" + this.props.data[0].horas.length}
                    key={'legend-matrix-' + this.props.name + i}
                  >{this.getHoraDia(i)}</div>
                )}
              </div>
              {/* <Grid item xs={12}>
                
              </Grid> */}

              {this.props.data.map((value, i) =>
                <MatrixLine
                  key={'line-matrix-' + this.props.name + i}
                  index={i}
                  data={value}
                  total={this.cant()}
                  name={this.props.name}
                  onClickGraphic={this.props.onClickGraphic}
                  isShort={this.props.data.length === 4}
                />
              )
              }
            </Grid>
          </Grid>
        </Grid>
        {
          this.getDate()
        }
      </Grid>
    )
  }
}

export default MatrixComponent;